import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LocationListComponent } from './pages/location-list/location-list.component';
import { LocationRoutes } from './location.routes';

const ROUTES: Routes = [{ path: LocationRoutes.LocationList, component: LocationListComponent }];

@NgModule({
    imports: [RouterModule.forChild(ROUTES)],
    exports: [RouterModule]
})
export class LocationRoutingModule {}
